import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';
import { push } from 'react-router-redux';

// api
import managerAPI from '../../sources/api/managerAPI';
import tokenAPI from '../../sources/api/tokenAPI';

// constants
import { CURRENT_MANAGER_CREATE } from '../../constants/currentManagerTypes';
import { TOKEN_CREATE } from '../../constants/tokenTypes';

// lib
import handleServerValidation from '../../lib/handleServerValidation';
import httpSaga from '../../lib/httpSaga';
import handleWizardNavigationOnError from '../../lib/handleWizardNavigationOnError';
import { queryParams } from '../../lib/queryParams';

const validationParams = [];

validationParams[0] = [
  'name', 'user.email', 'user.password', 'office.name', 'office.address',
  'office.city', 'office.state', 'office.postalCode', 'office.phoneNumber'
];

validationParams[1] = [
  'office.schedule'
];

validationParams[2] = [
  'office.holidays'
];

export function* currentManagerCreate(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const routing = yield select((state) => state.get('routing'));
  const step    = parseInt(routing.get('locationBeforeTransitions').query.step || 1, 10);
  const token = routing.get('locationBeforeTransitions').query.token;
  const params       = action.payload;
  const officeParams = params.office || {};

  if (token) {
    params.token = token;
  }
  if (officeParams.phoneNumber) {
    officeParams.phoneNumber = `+1${officeParams.phoneNumber.replace(/\D+/g, '')}`;
  }
  try {
    yield *httpSaga(CURRENT_MANAGER_CREATE, call(managerAPI.create, params));
    yield *httpSaga(TOKEN_CREATE, call(tokenAPI.create, params.email, params.password));

    yield put(push({ pathname: '/managers/new', search: queryParams({ token, step: step + 1 }) }));
  } catch (e) {
    const errors = handleServerValidation('manager', e.response.body.details, { nestedPath: true });

    yield *handleWizardNavigationOnError('/managers/new', step, errors, validationParams);

    yield put(error(CURRENT_MANAGER_CREATE, errors));
  } finally {
    yield put(doneIndicator(CURRENT_MANAGER_CREATE));
  }
}

export function* watchCurrentManagerCreate() {
  yield takeEvery(CURRENT_MANAGER_CREATE, currentManagerCreate);
}

export default function* root() {
  yield all([
    fork(watchCurrentManagerCreate)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/manager/currentManagerCreate.js